/**
 * Configurator API
 * Configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AbstractStepDTO } from './abstractStepDTO';

export interface EmailEventStepDTO extends AbstractStepDTO { 
    emailEvents: Array<EmailEventStepDTO.EmailEventsEnum>;
    templateId: string;
    tags?: Array<string>;
    link?: string;
}
export namespace EmailEventStepDTO {
    export type EmailEventsEnum = 'BOUNCES' | 'HARDBOUNCES' | 'SOFTBOUNCES' | 'DELIVERED' | 'SPAM' | 'REQUESTS' | 'OPENED' | 'CLICKS' | 'INVALID' | 'DEFERRED' | 'BLOCKED' | 'UNSUBSCRIBED' | 'ERROR' | 'LOADEDBYPROXY';
    export const EmailEventsEnum = {
        BOUNCES: 'BOUNCES' as EmailEventsEnum,
        HARDBOUNCES: 'HARDBOUNCES' as EmailEventsEnum,
        SOFTBOUNCES: 'SOFTBOUNCES' as EmailEventsEnum,
        DELIVERED: 'DELIVERED' as EmailEventsEnum,
        SPAM: 'SPAM' as EmailEventsEnum,
        REQUESTS: 'REQUESTS' as EmailEventsEnum,
        OPENED: 'OPENED' as EmailEventsEnum,
        CLICKS: 'CLICKS' as EmailEventsEnum,
        INVALID: 'INVALID' as EmailEventsEnum,
        DEFERRED: 'DEFERRED' as EmailEventsEnum,
        BLOCKED: 'BLOCKED' as EmailEventsEnum,
        UNSUBSCRIBED: 'UNSUBSCRIBED' as EmailEventsEnum,
        ERROR: 'ERROR' as EmailEventsEnum,
        LOADEDBYPROXY: 'LOADEDBYPROXY' as EmailEventsEnum
    };
}